
import mixin from "./mixin";
import { Component, Mixins } from "vue-property-decorator";
import * as modals from "@/lib/modals";
import TruckModule from "@/store/modules/truck";
import { getModule } from "vuex-module-decorators";
import notifications from "../../../lib/notifications";
import { formatDate } from "../../../utils";
import { FinalizeTruckResponse } from "@/models/api/trucks/finalizeTrucks";

const truckModuleState = getModule(TruckModule);

@Component({ name: modals.finalizeTruckModal })
export default class FinalizeTruckModal extends Mixins(mixin) {
  response: FinalizeTruckResponse = null;
  loading: boolean = true;
  finalizing: boolean = false;
  canFinalize: boolean = false;
  deliveryDateFormatted: string = null;
  truckId: number = null;
  async load() {
    this.show();

    let selectedTruck = this.selectedItem;
    this.truckId = selectedTruck.id;

    try {
      this.response = await truckModuleState.finalizeTruck({
        truckId: this.truckId
      });

      this.deliveryDateFormatted = formatDate(this.response.deliveryDate);

      this.canFinalize = this.response.canFinalize;
    } catch (ex) {}

    this.loading = false;
  }

  async finalizeTruck() {
    this.finalizing = true;
    try {
      const response = await truckModuleState.finalizeTruck({
        truckId: this.truckId,
        confirm: true
      });

      notifications.success("Finalize Truck", "Truck successfully finalized.");

      this.hideModal();
    } catch (ex) {
      notifications.error("Finalize Truck", "Failed to finalize truck", ex);
    }

    this.finalizing = false;
  }

  reset() {
    this.response = null;
    this.loading = true;
    this.finalizing = false;
    this.canFinalize = false;
    this.truckId = null;
    this.deliveryDateFormatted = null;
  }
}
